import { useEffect } from "react";

function upsertMetaByName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertMetaByProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  if (!data) return;
  let script = document.getElementById(id);
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

export default function SeoManager({
  title,
  description,
  canonical,
  robots = "index,follow",
  image = "https://prodsyncapp.com/app_icon.png",
  type = "website",
  jsonLd,
}) {
  useEffect(() => {
    document.documentElement.lang = "es";
    document.title = title;

    upsertMetaByName("description", description);
    upsertMetaByName("robots", robots);
    upsertMetaByName("twitter:card", "summary_large_image");
    upsertMetaByName("twitter:title", title);
    upsertMetaByName("twitter:description", description);
    upsertMetaByName("twitter:image", image);

    upsertMetaByProperty("og:title", title);
    upsertMetaByProperty("og:description", description);
    upsertMetaByProperty("og:image", image);
    upsertMetaByProperty("og:type", type);
    upsertMetaByProperty("og:url", canonical);
    upsertMetaByProperty("og:locale", "es_CO");
    upsertMetaByProperty("og:site_name", "PRODSYNC");

    upsertLink("canonical", canonical);

    if (jsonLd) {
      upsertJsonLd("seo-jsonld", jsonLd);
    }
  }, [canonical, description, image, jsonLd, robots, title, type]);

  return null;
}
